var _radialGradient, _linearGradient, _rect, _use, _use2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.4,
    cy: 1,
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff543e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c837ab"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 0.2,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3771c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#60f",
    stopOpacity: 0
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "c",
    height: 512,
    rx: "15%",
    width: 512
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#c"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 30
  }, /*#__PURE__*/React.createElement("rect", {
    height: 308,
    rx: 81,
    width: 308,
    x: 102,
    y: 102
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 165,
    r: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramImg);
export default __webpack_public_path__ + "static/media/instagramImg.e875e1407d05bc37ef439b87ff8c0ab2.svg";
export { ForwardRef as ReactComponent };